import React, { useContext } from 'react'
import './index.scss'
import WizardStepIndicators from '@Components/WizardFlow/WizardStepIndicators'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'

interface WizardFlowProps {
    heading?: string
}

const WizardFlow = ({ heading }: WizardFlowProps) => {
    const { wizardFlowStore } = useContext<RootStore>(StoresContext)

    const FormContent = () => {
        if (wizardFlowStore.currentFlowStep) {
            if (wizardFlowStore.currentSubIndex in wizardFlowStore.currentFlowStep.forms) {
                return wizardFlowStore.currentFlowStep.forms[wizardFlowStore.currentSubIndex]
            } else {
                throw new Error('Invalid wizard flow sub index')
            }
        }
        return undefined
    }

    const NavigationBar = () => {
        if (wizardFlowStore.currentFlowStep) {
            return wizardFlowStore.currentFlowStep.navigationBar
        }

        return undefined
    }

    return (
        <div className="wizard-flow">
            {heading && <h2>{heading}</h2>}

            <WizardStepIndicators steps={wizardFlowStore.flow} currentIndex={wizardFlowStore.currentIndex} />

            {FormContent()}

            {NavigationBar()}
        </div>
    )
}

export default observer(WizardFlow)
